<template>
  <!-- <div class="">
    <button type="button" class="btn btn-outline-primary" v-on:click="goPrev" v-bind:disabled="!hasPrev">Previous</button>
    <button type="button" class="btn btn-outline-secondary" v-on:click="goNext" v-bind:disabled="!hasNext">Next</button>
  </div> -->
  <div class="controller">
    <div class="btn-group btn-group-sm" role="group" aria-label="Basic example">
      <button type="button" class="btn btn-secondary" v-on:click="goPrev" v-bind:disabled="!hasPrev">Previous</button>
      <button type="button" v-if="currentCollId" class="btn btn-primary" v-on:click="newCard">+ New Card</button>
      <button type="button" v-if="currentCard" class="btn btn-danger" v-on:click="delCard">Delete</button>
      <button type="button" v-if="currentCard" class="btn btn-warning" v-on:click="editCard">Edit</button>
      <button type="button" class="btn btn-secondary" v-on:click="goNext" v-bind:disabled="!hasNext">Next</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardController',
  props: ['hasNext', 'hasPrev', 'currentCollId', "currentCard"],
  methods: {
    goPrev: function(){
      this.$emit("goPrev")
    },
    goNext: function(){
      this.$emit("goNext")
    },
    newCard() {
      this.$emit("newCard")
    },
    delCard() {
      this.$emit("delCard")
    },
    editCard(){
      this.$emit("editCard")
    }
  }
}
</script>

<style scoped>
  .controller {
    position: fixed;
    bottom: 2rem;
    left: 50%;
    transform: translate(-50%, 0);
    min-width: 300px;
  }
</style>
